<template>
  <div>
    <vonap-window
      width="832px"
      height="682px"
      title="Email preview"
      modal
      @close="close"
      v-model="show"
    >
      <b>Client: </b><span>{{ clientName }} </span> <b>Subject: </b><span v-html="subject"></span>
      <v-card>
        <v-container grid-list-xl text-xs-center style="background-color:#e3e3e3">
          <span v-html="message"></span>
        </v-container>
      </v-card>
    </vonap-window>
  </div>
</template>

<script>
import axios from 'axios'
import VonapWindow from '@/components/VonapWindow'
import notification from '@/helpers/notification'

export default {
  name: 'DashboardBonCoupPreview',
  components: {
    VonapWindow,
  },
  props: {
    value: {type: Boolean},
    monthlyReportSendingId: {type: Number},
    monthlyReportSendingListDetailId: {type: Number},
    asOfDate: {type: String},
  },
  data() {
    return {
      clientName: '',
      subject: '',
      message: '',
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set() {},
    },
  },
  methods: {
    async getData() {
      const data = {
        monthlyReportSendingId: this.monthlyReportSendingId,
        monthlyReportSendingListDetailId: this.monthlyReportSendingListDetailId,
        url: location.origin,
        asOfDate: this.asOfDate,
      }
      const response = await axios
        .post('/api/report/monthlyReportSendingList/GetBonCoupMail', data)
        .catch(() => {
          notification('Some error', 'error')
        })

      this.clientName = response.data.clientName
      this.subject = response.data.subject
      this.message = response.data.message
    },
    close() {
      this.$emit('input', false)
    },
  },
  watch: {
    monthlyReportSendingId(newVal) {
      if (newVal) {
        this.getData()
      }
    },
    monthlyReportSendingListDetailId(newValue) {
      if (newValue) {
        this.getData()
      }
    },
  },
}
</script>
